<template>
  <v-layout row wrap>
    <v-flex xs12 class="pt-0">
      <v-data-table
        :headers="headers"
        :items="listItems"
        :total-items="totalItems"
        :pagination.sync="pagination"
        :rows-per-page-items="rowsPerPageItems"
        :loading="loading"
        class="ch-table-list"
      >
        <template slot="headers" slot-scope="props">
          <tr>
            <th v-for="header in props.headers" :key="header.text"
              class="text-xs-left"
              :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
              @click="changeSort(header.value)"
            >
              {{ header.text }}
              <v-icon v-if="sortableList.includes(header.value)">arrow_upward</v-icon>
            </th>
          </tr>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-left list-btn" width="5%">
            <router-link
              :to="{ name: 'hotelsDetailInfo', params: { id: props.item.id } }"
            ><i class="fas fa-search"></i></router-link>
          </td>
          <td class="text-xs-left" v-if="visibleDomain" width="15%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.domain_name }}</span><pre>{{ props.item.domain_name }}</pre></v-tooltip></td>
          <td class="text-xs-left" width="15%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.name }}</span><pre>{{ props.item.name }}</pre></v-tooltip></td>
          <td class="text-xs-left" width="15%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.timezone }}</span><pre>{{ props.item.timezone }}</pre></v-tooltip></td>
          <td class="text-xs-left" width="10%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.desc }}</span><pre>{{ props.item.desc }}</pre></v-tooltip></td>
          <td class="text-xs-left" width="10%"><v-tooltip bottom color="primary" ><span slot="activator">{{ getTimeToString(props.item.checkin_hour, props.item.checkin_minute) }}</span><pre>{{ getTimeToString(props.item.checkin_hour, props.item.checkin_minute) }}</pre></v-tooltip></td>
          <td class="text-xs-left" v-if="visibleTag" width="10%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.tag }}</span><pre>{{ props.item.tag }}</pre></v-tooltip></td>
          <td class="text-xs-left" v-if="visibleType" width="10%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.type }}</span><pre>{{ props.item.type }}</pre></v-tooltip></td>
          <td class="text-xs-left" width="10%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.updated_at | moment("YYYY-MM-DD HH:mm:ss") }}</span><pre>{{ props.item.updated_at | moment("YYYY-MM-DD HH:mm:ss") }}</pre></v-tooltip></td>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
  import _ from 'lodash';
  import { storeFilterEventBus } from '@/components/customized-components/storeFilterEventBus';
  import { hotelsEventBus } from '@/components/admin/hotels/hotelsEventBus';
  import api from '../../../api';

  export default {
    props: ['storeFilter', 'storePage'],
    data() {
      return {
        // NOTE: first init
        isInit: false,
        // NOTE: Table List
        loading: false,
        pagination: {
          sortBy: null,
          descending: null,
          rowsPerPage: 20,
        },
        totalItems: 0,
        visibleDomain: false,
        visibleType: false,
        visibleTag: false,
        headers: [
          { text: 'View', value: 'hotel_id', align: 'left', sortable: false },
          { text: 'Domain', value: 'domain_name', align: 'left', sortable: false },
          { text: 'Name', value: 'hotel_name', align: 'left', sortable: false },
          { text: 'Timezone', value: 'timezone', align: 'left', sortable: false },
          { text: 'Description', value: 'desc', align: 'left', sortable: false },
          { text: 'Checkin/Checkout', value: 'checkinout', align: 'left', sortable: false },
          { text: 'Tag', value: 'tag', align: 'left', sortable: false },
          { text: 'Type', value: 'type', align: 'left', sortable: false },
          { text: 'Updated at', value: 'updated_at', align: 'left' },
        ],
        rowsPerPageItems: [20, 50],
        sortableList: ['updated_at'],
        // NOTE: Data
        listItems: [],    // 실제 서버에서 받아온 원본 리스트
        filter: [],       // 쿼리문을 담을 배열
      };
    },
    methods: {
      /**
       * @description 필터에 정보가 없을경우 최초 한번만 실행,
       * 필터에 정보가 존재할 경우에는 BookingsFilter에서 eventbus 실행됨
       */
      init() {
        if (_.isEmpty(this.storeFilter)) {
          this.getHotelList();
        }
      },
      getHotelList() {
        this.loading = true;
        const sortStr = this.pagination.sortBy;
        let orderStr = null;
        if (this.pagination.descending === null) {
          orderStr = null;
        } else if (this.pagination.descending === false) {
          orderStr = 'asc';
        } else if (this.pagination.descending === true) {
          orderStr = 'desc';
        }
        const querystring = {
          sort: sortStr,
          order: orderStr,
          offset: (this.pagination.page - 1) * this.pagination.rowsPerPage,
          limit: this.pagination.rowsPerPage,
          pagination: true,
        };
        for (let index = 0; index < this.filter.length; index += 1) {
          querystring[this.filter[index].searchCategory] = this.filter[index].search;
        }
        api.getHotelList(querystring)
        .then((result) => {
          if (result.status === 200) {
            this.listItems = result.data.items;
            this.totalItems = result.data.total;
            this.loading = false;
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
          this.loading = false;
        });
      },
      /**
       * @description 오름차순/내림차순 정렬
       */
      changeSort(column) {
        if (this.sortableList.includes(column)) {
          if (this.pagination.sortBy === column) {
            this.pagination.descending = !this.pagination.descending;
          } else {
            this.pagination.sortBy = column;
            this.pagination.descending = false;
          }
        }
      },
      /**
       * @description 시(hour), 분(minute)을 받아서 하나의 문자열로 반환
       * @param { Number } hour
       * @param { Number } minute
       * @returns { String }
       */
      getTimeToString(hour, minute) {
        let newhour = null;
        let newMinute = null;

        function numberToString(number) {
          let newNumber = number;
          if (number < 9) newNumber = `0${number.toString()}`;
          else newNumber = number.toString();
          return newNumber;
        }

        newhour = numberToString(hour);
        newMinute = numberToString(minute);

        return `${newhour}:${newMinute}`;
      },
    },
    watch: {
      pagination: {
        deep: true,
        handler() {
          if (this.isInit) {
            console.log('handler');
            this.getHotelList();
          }
        },
      },
    },
    computed: {
      pages() {
        /* eslint max-len: ["error", { "code": 200 }] */
        return this.pagination.rowsPerPage ? Math.ceil(this.listItems.length / this.pagination.rowsPerPage) : 0;
      },
    },
    created() {
      if (localStorage.getItem('domain_type') === 'root') {
        this.visibleDomain = true;
        this.visibleTag = true;
        this.visibleType = true;
      } else {
        let index;
        index = _.findIndex(this.headers, { text: 'Domain' });
        this.headers.splice(index, 1);
        index = _.findIndex(this.headers, { text: 'Tag' });
        this.headers.splice(index, 1);
        index = _.findIndex(this.headers, { text: 'Type' });
        this.headers.splice(index, 1);
      }
    },
    mounted() {
      console.log('hotellist mount');
      this.init();
      // NOTE: 페이지 로드
      this.$nextTick(() => {
        this.isInit = true;
      });
      this.$nextTick(() => {
        if (!_.isEmpty(this.storePage)) {
          this.pagination = Object.assign({}, this.storePage);
          this.getHotelList();
        }
      });
      hotelsEventBus.$on('initFilter', (obj) => {
        console.log('initFilter');
        this.filter = Object.values(obj).filter(item => item.search !== null);
        this.getHotelList();
      });
      hotelsEventBus.$on('customFilter', (obj) => {
        this.filter = Object.values(obj).filter(item => item.search !== null);
        // NOTE: 검색조건이 바뀌므로 첫 페이지로 이동
        this.pagination.page = 1;
        this.getHotelList();
      });
      hotelsEventBus.$on('reloadList', () => this.getHotelList());
    },
    updated() {
      storeFilterEventBus.$emit('setPage', this.pagination);
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/hotels/HotelsList.vue